export const simpleIsEqual = (obj1: any, obj2: any): boolean => {
  if (obj1 === null && obj2 === null) return true
  if (obj1 === null || obj2 === null) return false
  return JSON.stringify(obj1) === JSON.stringify(obj2)
}
